import {Component} from "@angular/core";

@Component({
    moduleId: module.id, 
    selector: "FilmCritClient",
    templateUrl: "app.component.html"
})
export class AppComponent{

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/app/app.component.ts